var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reservation-payment',{attrs:{"charge":_vm.charge,"payload":_vm.chargePayload,"property":_vm.property,"reservation":_vm.reservation,"provider":_vm.paymentProvider},on:{"payment":_vm.paymentMade}})}
var staticRenderFns = []

export { render, staticRenderFns }